import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, WarningSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "errorMessage": "ErrorMessage-module_errorMessage__G7JqV",
    "errorMessageIcon": "ErrorMessage-module_errorMessageIcon__K8L21",
    "errorMessageText": "ErrorMessage-module_errorMessageText__ezseJ"
};

const ErrorMessage = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, showError, children }, ref)=>{
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        id: id,
        lang: lang,
        "data-testid": dataTestId,
        "aria-live": 'assertive',
        "aria-atomic": true,
        children: showError && /*#__PURE__*/ jsxs("div", {
            className: `${styles.errorMessage} ${className}`.trim(),
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    svgPath: WarningSVGpath,
                    size: 'small',
                    className: styles.errorMessageIcon
                }),
                /*#__PURE__*/ jsx("p", {
                    className: styles.errorMessageText,
                    children: children
                })
            ]
        })
    });
});
ErrorMessage.displayName = 'ErrorMessage';

export { ErrorMessage };
